import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listValueToString',
  pure: true
})
export class ListValueToStringPipe implements PipeTransform {
  
  transform(value: any, format?: string, format2?: string): any { 
    if (!value) { return ''; }
    
    if (format2) {
      return value.map(v => v[format][format2]).join(", "); 
    } else if (format) {
      return value.map(v => v[format]).join(", ");    
    } else {
      return value.join(", ");
    }
  }

}
